import { isValidPhoneNumber } from 'libphonenumber-js'

const isValidFrNumber = function (node) {
  return isValidPhoneNumber(node.value, 'FR')
}

export default isValidFrNumber
